(function () {
  const TEST_MODE = new URLSearchParams(window.location.search).has('test');
  const TEST_HUBSPOT_FORM_ID = "ccd24e21-556b-40f8-9774-ec80aaece874";
  const PROD_HUBSPOT_FORM_ID = "5d69ffbe-3935-43c0-b175-aee35bf66c6b";
  if (TEST_MODE) console.warn("⚠️ TEST MODE — form submissions going to HubSpot test form. Add ?test to URL to enable.");

  // Checkbox groups serialized to one HubSpot field each, values ;-joined.
  // service_type is NOT listed here — it is assembled specially in
  // onFormSubmit (Other free text merge, derived service_category).
  const MULTI_CHECKBOX_GROUPS = ["preferred_days", "preferred_time_blocks"];

  const GENERIC_ERROR = "Something went wrong submitting the form. Please try again.";

  let form, mode, submitBtn, errorEl, thankyouEl, serviceBoxes, otherBox, otherField, otherInput;

  // Script is deferred, so the DOM is parsed. Wire documents mode now rather
  // than on DOMContentLoaded so the HubSpot on-ready event can't beat us.
  if (document.getElementById('VendorDocuments')) {
    wireDocuments();
    return;
  }

  document.addEventListener('DOMContentLoaded', function () {
    form = document.querySelector("#VendorAgreementForm");
    if (!form) return;
    mode = form.dataset.formMode || 'full';
    submitBtn = form.querySelector('button[type="submit"]');
    errorEl = form.querySelector('.vendor-form__error');
    thankyouEl = form.parentElement.querySelector('.vendor-form__thankyou');

    // Service picker only exists in full/info modes — wire it only when present
    // so agreement-only mode still reaches the submit handler.
    serviceBoxes = form.querySelectorAll('input[name="service_type"]');
    if (serviceBoxes.length) {
      otherBox = form.querySelector('#ServiceTypeOther');
      otherField = form.querySelector('#ServiceTypeOtherField');
      otherInput = form.querySelector('#ContactForm-service-type-other');
      serviceBoxes.forEach(function (cb) { cb.addEventListener('change', updateServicesValidity); });
      otherBox.addEventListener('change', updateOtherVisibility);
      updateServicesValidity();
      updateOtherVisibility();
    }

    // Agreement mode: prefill identity from the step link so a returning
    // vendor's submission upserts onto their existing HubSpot record.
    if (mode === 'agreement') prefillIdentityFromUrl();

    form.addEventListener('submit', onFormSubmit);
  });

  // Documents mode: the page is only the HubSpot W9/COI form (one email, one
  // Submit). Prefill identity carried from the info step via HubSpot's v4
  // developer API, then continue to the agreement step with the same identity.
  // ?test can't reroute an embedded form — it still submits to the real form;
  // test mode only suppresses the redirect so QA can inspect the result.
  function wireDocuments() {
    const params = new URLSearchParams(window.location.search);
    const prefill = { '0-1/email': params.get('email'), '0-2/name': params.get('company') };

    window.addEventListener('hs-form-event:on-ready', function (event) {
      const hsForm = window.HubSpotFormsV4.getFormFromEvent(event);
      Object.keys(prefill).forEach(function (name) {
        if (prefill[name]) hsForm.setFieldValue(name, prefill[name]);
      });
    });

    window.addEventListener('hs-form-event:on-submission:success', async function (event) {
      let values = [];
      try {
        values = await window.HubSpotFormsV4.getFormFromEvent(event).getFormFieldValues();
      } catch (err) {
        console.error("couldn't read submitted values; falling back to URL identity", err);
      }
      const submitted = function (name) {
        const field = (values || []).find(function (v) { return v.name === name; });
        return field && field.value ? String(field.value).trim() : '';
      };
      const next = new URLSearchParams();
      const email = submitted('0-1/email') || prefill['0-1/email'];
      const company = submitted('0-2/name') || prefill['0-2/name'];
      if (email) next.set('email', email);
      if (company) next.set('company', company);
      next.set('agree', '1');
      const url = '/pages/vendor-agreement?' + next.toString();
      if (TEST_MODE) {
        showTestConfirmation("Documents submitted to the LIVE HubSpot form. Next step would be " + url);
        return;
      }
      window.location.assign(url);
    });
  }

  function prefillIdentityFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const email = params.get('email');
    const company = params.get('company');
    const emailEl = form.querySelector('#ContactForm-email');
    const nameEl = form.querySelector('#ContactForm-name');
    if (email && emailEl && !emailEl.value) emailEl.value = email;
    if (company && nameEl && !nameEl.value) nameEl.value = company;
  }

  // Native checkbox `required` can't express "at least one of the group":
  // mark one services checkbox invalid while none are checked so
  // reportValidity() gates on at-least-one-selected. Anchored on the "Other"
  // box (last in the group) because it sits outside the collapsed <details>
  // accordions — reportValidity() cannot focus a box inside a closed one.
  function updateServicesValidity() {
    const anyChecked = Array.prototype.some.call(serviceBoxes, function (cb) { return cb.checked; });
    serviceBoxes[serviceBoxes.length - 1].setCustomValidity(anyChecked ? "" : "Please select at least one service.");
  }

  function updateOtherVisibility() {
    otherField.hidden = !otherBox.checked;
    otherInput.required = otherBox.checked;
  }

  function showError(message) {
    errorEl.textContent = message;
    errorEl.hidden = false;
    errorEl.focus();
  }

  function hideError() {
    errorEl.hidden = true;
    errorEl.textContent = "";
  }

  function resetSubmitButton(label) {
    submitBtn.disabled = false;
    submitBtn.textContent = label;
  }

  function showThankyou() {
    // Info step has no interstitial — go straight to the documents step,
    // carrying identity so it upserts the same record. Test mode keeps the
    // interstitial + banner so QA can inspect the submission result.
    if (mode === 'info' && !TEST_MODE) {
      window.location.assign('/pages/vendor-documents?' + identityParams().toString());
      return;
    }
    if (mode === 'info') buildAgreementCta();
    form.hidden = true;
    thankyouEl.hidden = false;
    prefillUploadEmbed(thankyouEl);
  }

  // The thank-you screen hosts a HubSpot upload embed (raw-HTML developer
  // embed) — carry the just-submitted email into it so the upload associates
  // with the same contact record without re-typing. The embed renders
  // asynchronously (deferred script + form-definition fetch), so if its email
  // input isn't in the DOM yet, watch for it instead of silently giving up.
  function prefillUploadEmbed(root) {
    if (!root) return;
    const emailEl = form.querySelector('#ContactForm-email');
    if (!emailEl) return;
    const email = emailEl.value.trim();
    if (email === "") return;
    if (fillUploadEmail(email, root)) return;
    const observer = new MutationObserver(function () {
      if (fillUploadEmail(email, root)) observer.disconnect();
    });
    observer.observe(root, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 20000);
  }

  function fillUploadEmail(email, root) {
    // New-editor forms prefix field names with the object type id ("0-1/email").
    const input = root.querySelector('.hs-form-html input[name="0-1/email"], .hs-form-html input[name="email"]');
    if (!input) return false;
    if (!input.value) {
      // Set via the native setter so HubSpot's (React-based) form state
      // registers the value, not just the visible DOM attribute.
      const desc = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
      if (desc && desc.set) { desc.set.call(input, email); } else { input.value = email; }
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  // Offer an immediate "continue to the next step" link carrying the vendor's
  // company + email so the next step prefills identity and upserts the same
  // HubSpot record. Progression: info -> documents -> agreement.
  // Identity (email + company) carried step-to-step in the querystring so each
  // step prefills and upserts the same HubSpot record.
  function identityParams() {
    const emailEl = form.querySelector('#ContactForm-email');
    const nameEl = form.querySelector('#ContactForm-name');
    const params = new URLSearchParams();
    if (emailEl && emailEl.value.trim()) params.set('email', emailEl.value.trim());
    if (nameEl && nameEl.value.trim()) params.set('company', nameEl.value.trim());
    return params;
  }

  function buildAgreementCta() {
    const cta = document.getElementById('vendor-agreement-cta');
    const link = document.getElementById('vendor-agreement-link');
    if (!cta || !link) return;
    const params = identityParams();
    link.href = '/pages/vendor-documents?' + params.toString();
    link.textContent = 'Continue to documents & background checks →';
    cta.hidden = false;
  }

  async function onFormSubmit(event) {
    event.preventDefault();
    hideError();

    // Recompute from actual checkbox state — autofill/session restore can
    // re-check boxes without firing change events. Only when the picker exists.
    if (serviceBoxes.length) {
      updateServicesValidity();
      updateOtherVisibility();
    }

    if (!form.reportValidity()) {
      console.log("Form validation failed");
      return;
    }

    // Cross-field check: minimum residents must not exceed maximum (info/full only)
    const minEl = form.querySelector('#ContactForm-min-residents');
    const maxEl = form.querySelector('#ContactForm-max-residents');
    if (minEl && maxEl) {
      const minVal = minEl.value.trim();
      const maxVal = maxEl.value.trim();
      if (minVal !== "" && maxVal !== "" && Number(minVal) > Number(maxVal)) {
        showError("Maximum residents per day must be greater than or equal to the minimum per visit.");
        return;
      }
    }

    const formData = new FormData(form);
    const fields = [];
    const groupValues = {};

    // HubSpot form 5d69ffbe defines these as company (0-2) properties;
    // the rest are contact (0-1). Submitting with the wrong objectTypeId
    // fails the whole request with REQUIRED_FIELD errors.
    const COMPANY_FIELDS = [
      "name", "address", "service_type", "service_category", "vendor_agreement_status",
      "payment_terms", "payment_method", "payment_changes", "cancellation_policy", "confirm_pricing",
      "n8_transact_fee", "nda", "indemnify", "violations", "sign_name",
      "transact_fee_agreement", "transact_fee_agreement_version",
    ];
    function objectTypeId(key) {
      return COMPANY_FIELDS.indexOf(key) !== -1 ? "0-2" : "0-1";
    }

    formData.forEach(function (value, key) {
      // Assembled below from serviceBoxes; service_type_other merges into it.
      if (key === "service_type" || key === "service_type_other") return;
      if (MULTI_CHECKBOX_GROUPS.indexOf(key) !== -1) {
        (groupValues[key] = groupValues[key] || []).push(value);
        return;
      }
      // Omit blank optional values; required fields are sent as-is so a
      // whitespace-only value fails visibly in HubSpot rather than vanishing.
      if (typeof value === "string" && value.trim() === "") {
        const el = form.elements[key];
        if (!(el && el.required)) return;
      }
      fields.push({ "objectTypeId": objectTypeId(key), "name": key, "value": value });
    });

    MULTI_CHECKBOX_GROUPS.forEach(function (key) {
      if (groupValues[key]) {
        fields.push({ "objectTypeId": objectTypeId(key), "name": key, "value": groupValues[key].join(";") });
      }
    });

    // Services: companies.service_type is free text — join the canonical
    // labels, folding the Other free text in. companies.service_category is a
    // single-select enum, so the first non-Other selection wins; Other-only
    // submissions land in the residual "Other / To Be Determined" bucket.
    if (serviceBoxes.length) {
      const checkedServices = Array.prototype.filter.call(serviceBoxes, function (cb) { return cb.checked; });
      const serviceValues = checkedServices.map(function (cb) {
        const otherText = otherInput.value.trim();
        return cb.value === "Other" && otherText !== "" ? "Other: " + otherText : cb.value;
      });
      fields.push({ "objectTypeId": "0-2", "name": "service_type", "value": serviceValues.join("; ") });
      const primary = checkedServices.filter(function (cb) { return cb.value !== "Other"; })[0] || checkedServices[0];
      fields.push({ "objectTypeId": "0-2", "name": "service_category", "value": primary.dataset.category });
    }

    const formId = TEST_MODE ? TEST_HUBSPOT_FORM_ID : PROD_HUBSPOT_FORM_ID;
    const url = `https://api.hsforms.com/submissions/v3/integration/submit/21709739/${formId}`;

    const requestData = {
      "submittedAt": Date.now(),
      "fields": fields,
      "context": {
        "pageUri": window.location.href,
        "pageName": document.title,
      }
    };

    const hubspotutk = getCookie('hubspotutk');
    if (hubspotutk) {
      requestData.context.hutk = hubspotutk;
    }

    const originalLabel = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = "Submitting…";

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData)
      });

      if (!response.ok) {
        console.error("form submit failed with status", response.status);
        showError(GENERIC_ERROR);
        resetSubmitButton(originalLabel);
        return;
      }

      // Same reveal path in test and prod so ?test QA exercises the real
      // success DOM mechanics; the banner marks it as a test submission.
      showThankyou();
      if (TEST_MODE) {
        showTestConfirmation("Form submitted to test HubSpot. Reload the page to submit again.");
      }
    } catch (err) {
      console.error("failed during form submit", err);
      showError(GENERIC_ERROR);
      resetSubmitButton(originalLabel);
    }
  }

  function showTestConfirmation(message) {
    console.log("✅ " + message);
    var banner = document.getElementById("vendor-test-banner");
    if (!banner) {
      banner = document.createElement("div");
      banner.id = "vendor-test-banner";
      banner.style.cssText = "position:fixed;top:0;left:0;right:0;padding:16px;background:#065f46;color:white;text-align:center;z-index:99999;font-size:16px;";
      document.body.appendChild(banner);
    }
    banner.textContent = "✅ TEST: " + message;
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie;
    try {
      decodedCookie = decodeURIComponent(document.cookie);
    } catch (err) {
      // A malformed %-sequence in any cookie must not block submission —
      // hutk context is optional.
      return "";
    }
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
})();
